import React, { createContext, useContext } from "react";
import type { ProjectTemplateWizardDialogContext } from "./ProjectTemplateLayout";
const WizardDialogContext = createContext<ProjectTemplateWizardDialogContext | null>(null);
export function ProjectTemplateWizardDialogContextProvider({ children, value }: {
    children: React.ReactNode;
    value: ProjectTemplateWizardDialogContext;
}) {
    return <WizardDialogContext.Provider value={value}>{children}</WizardDialogContext.Provider>;
}
export function useProjectTemplateWizardDialog(): ProjectTemplateWizardDialogContext {
    const context = useContext(WizardDialogContext);
    if (!context) {
        throw new Error("useProjectTemplateWizardDialog must be used within a ProjectTemplateWizardDialogContextProvider");
    }
    return context;
}
